import { render, staticRenderFns } from "./EconomyCard.vue?vue&type=template&id=54db6692"
import script from "./EconomyCard.vue?vue&type=script&lang=js"
export * from "./EconomyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports